import { useSearchParameter } from './useSearchParameter.js';
import {
  isValidTemplate,
  isValidTheme,
  type TemplateNames,
  type ThemeNames,
} from '@/templates/templateTypes.js';

export const useStyleOverrideParameter = (): {
  styleOverride: string | null;
  templateSlug: TemplateNames | null;
  themeSlug: ThemeNames | null;
} => {
  const styleOverride = useSearchParameter('styleOverride', 'string');

  if (!styleOverride) {
    return {
      styleOverride: null,
      templateSlug: null,
      themeSlug: null,
    };
  }

  const [templateSlug, themeSlug] = styleOverride.split(':');

  if (
    !templateSlug ||
    !themeSlug ||
    (!isValidTemplate(templateSlug) && !isValidTheme(themeSlug))
  ) {
    return {
      styleOverride: null,
      templateSlug: null,
      themeSlug: null,
    };
  }

  return isValidTemplate(templateSlug) && isValidTheme(themeSlug)
    ? {
        styleOverride,
        templateSlug,
        themeSlug,
      }
    : {
        styleOverride: null,
        templateSlug: null,
        themeSlug: null,
      };
};
